module.exports = __webpack_public_path__ + "static/media/icon-sun.eafa19dd.svg";